import React, { useEffect, useState } from "react";
import { all_routes } from "../../router/all_routes";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import PredefinedDateRanges from "../../../core/common/datePicker";
import EmpSuccess from "../employees/employeeSuccess";
import "../employees/index.css";
import { addNewExpenses } from "../../../apis/expences";
import { Moment } from "moment";
import { getAllDisburseData } from "../../../apis/disbursement";
import * as XLSX from "xlsx";

const DisburseMent_Loan = () => {
  const initialValues = {
    name: "",
    rate: "",
    address: "",
  };

  const [allEmployeeData, setEmployeeData] = useState<EmployeeData[]>([]);
  const [successCreation, setSuccessCreation] = useState<boolean>(false);
  const [formData, setFormData] = useState(initialValues);
  const { name, rate, address } = formData;
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [state, setState] = useState<{
    start: Moment | undefined;
    end: Moment | undefined;
  }>({
    start: undefined,
    end: undefined,
  });
  const { start, end } = state;

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  type EmployeeData = {
    [x: string]: any;
    key: number;
    type: string;
    other_charges: string;
    file_charges: string;
    id: any;
    rate: number;
    disbursement_date: string;
    start_date: string;
    createdAt: string;
    Status: string;
  };
  const loginData = sessionStorage.getItem("info");
  const fetchAllEmployees = async () => {
    try {
      const data = {
        start_date: start ? start.format("MM/DD/YYYY") : undefined,
        end_date: end ? end.format("MM/DD/YYYY") : undefined,
        user_id: JSON.parse(loginData).id,
        type: JSON.parse(loginData).type,
      };
      const response = await getAllDisburseData(data);
      const formattedData = response?.data?.loanDetails?.map(
        (loan: any, index: number) => {
          const disbursement = loan?.emi_details?.disbursement || {};
          const grossAmount =
            disbursement?.gross_amount ??
            disbursement?.amount ??
            loan?.approvalAmount ??
            0;
          const settlementAmount =
            disbursement?.settlement_amount ?? loan?.settlement_amount ?? 0;
          const netAmount =
            disbursement?.net_amount ??
            loan?.net_disbursement_amount ??
            Number(grossAmount) - Number(settlementAmount);

          return {
            key: index + 1,
            EmpId: loan.id || "-",
            Name: loan.customer.full_name || "-",
            Email: loan.customer.email || "-",
            Phone: loan.customer.phoneNumber1 || "-",
            loanAdddate: disbursement?.disbursement_date
              ? new Date(disbursement.disbursement_date).toLocaleDateString()
              : loan.createdAt
                ? new Date(loan.createdAt).toLocaleDateString()
                : "-",
            approvalAmount: loan?.approvalAmount || "--",
            grossDisbursementAmount: Number(grossAmount) || 0,
            settlementAmount: Number(settlementAmount) || 0,
            netDisbursementAmount: Number(netAmount) || 0,
            approvalDate: loan?.approvalDate || "",
            geo_location: loan.geo_location || "-",
            address: loan.address || "-",
            Status: loan.status || "Pending",
            loanAccountNumber: loan.customer.loanAccountNumber || "--",
            loan_id: loan.loan_id,
            id: loan.id,
            allDetails: loan,
          };
        }
      );
      // setLoansData(formattedData);
      setEmployeeData(formattedData || []);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  useEffect(() => {
    fetchAllEmployees();
  }, [state]);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  // Search across every visible field.
  const filteredEmployeeData = React.useMemo(() => {
    const query = searchQuery.trim().toLowerCase();
    if (!query) return allEmployeeData;

    return allEmployeeData.filter((item) =>
      [
        item.Name,
        item.Email,
        item.Phone,
        item.loanAccountNumber,
        item.loan_id,
        item.approvalAmount,
        item.approvalDate,
        item.Status,
        item.loanAdddate,
      ].some((value) => String(value ?? "").toLowerCase().includes(query))
    );
  }, [allEmployeeData, searchQuery]);

  const totalDisbursementAmount = React.useMemo(
    () =>
      filteredEmployeeData.reduce(
        (sum, item) => sum + (Number(item.grossDisbursementAmount) || 0),
        0
      ),
    [filteredEmployeeData]
  );

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(allEmployeeData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "EmployeeData");
    XLSX.writeFile(workbook, "employee_data.xlsx");
  };

  type LoanData = {
    loan_id: any;
    key: number;
    EmpId: string;
    Name: string;
    Image: string;
    Email: string;
    Phone: string;
    loanAdddate: string;
    approvalAmount: string;
    approvalDate: string;
    geo_location: string;
    address: any;
    Status: string;
    loanAccountNumber: string;
    id: any;
    allDetails: any;
  };

  const columns = [
    {
      title: "Sr No",
      dataIndex: "key",
      render: (text: string) => <span>{text}</span>,
      sorter: (a: LoanData, b: LoanData) => a.EmpId.localeCompare(b.EmpId),
    },
    {
      title: "Date",
      dataIndex: "loanAdddate",
      sorter: (a: LoanData, b: LoanData) =>
        new Date(a.loanAdddate).getTime() - new Date(b.loanAdddate).getTime(),
    },
    {
      title: "Customer Accoun Number",
      dataIndex: "loanAccountNumber",
      sorter: (a: LoanData, b: LoanData) =>
        a.loanAccountNumber.localeCompare(b.loanAccountNumber),
    },
    {
      title: "Loan Account Number",
      dataIndex: "loan_id",
      sorter: (a: LoanData, b: LoanData) => a.loan_id.localeCompare(b.loan_id),
    },
    {
      title: "Name",
      dataIndex: "Name",
      render: (_: any, record: LoanData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">{record.Name}</p>
          </div>
        </div>
      ),
      sorter: (a: LoanData, b: LoanData) => a.Name.localeCompare(b.Name),
    },
    {
      title: "Email",
      dataIndex: "Email",
      sorter: (a: LoanData, b: LoanData) => a.Email.localeCompare(b.Email),
    },
    {
      title: "Phone",
      dataIndex: "Phone",
      sorter: (a: LoanData, b: LoanData) => a.Phone.localeCompare(b.Phone),
    },
    {
      title: "Approval Date",
      dataIndex: "approvalDate",
      sorter: (a: LoanData, b: LoanData) =>
        new Date(a.approvalDate).getTime() - new Date(b.approvalDate).getTime(),
    },
    {
      title: "Approval Amount",
      dataIndex: "approvalAmount",
      sorter: (a: LoanData, b: LoanData) =>
        a.approvalAmount.localeCompare(b.approvalAmount),
    },
    {
      title: "Gross Disbursement",
      dataIndex: "grossDisbursementAmount",
    },
    {
      title: "Settlement Deduction",
      dataIndex: "settlementAmount",
    },
    {
      title: "Net Disbursement",
      dataIndex: "netDisbursementAmount",
    },
    // {
    //   title: "Parent Name",
    //   dataIndex: "address",
    //   render: (text: string, record: LoanData) => (
    //     <div className="ms-2">
    //       <p className="text-dark mb-0">
    //         <div>{"Paybia Finance"}</div>
    //       </p>
    //     </div>
    //   ),
    // },
    // {
    //   title: "Owner Name",
    //   dataIndex: "address",
    //   render: (text: string, record: LoanData) => (
    //     <div className="ms-2">
    //       <p className="text-dark mb-0">
    //         <div>{"Master"}</div>
    //       </p>
    //     </div>
    //   ),
    // },

    {
      title: "Status",
      dataIndex: "Status",
      render: (text: string, record: LoanData) => (
        <span className="dropdown">
          <div
            className={`badge  btn btn-white ${
              text === "Active" ? "badge-success" : "badge-danger"
            } d-inline-flex align-items-center badge-xs`}
            data-bs-toggle="dropdown"
          >
            <i className="ti ti-point-filled me-1" />
            {text}
          </div>
        </span>
      ),
      sorter: (a: LoanData, b: LoanData) => a.Status.localeCompare(b.Status),
    },
  ];

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    let idData: any;
    if (loginData) {
      const response = JSON.parse(loginData);
      idData = response;
    }

    const payload = {
      status: "active",
      user_id: idData.user_id,
      user_type: idData.type,
      amount: formData.rate,
      title: formData.name,
      description: formData.address,
    };
    try {
      const response = await addNewExpenses(payload);
      if (response.status === true) {
        setSuccessCreation(true);
        fetchAllEmployees();
      }
    } catch (error) {}
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2"></div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="me-2 mb-2"></div>
            </div>
          </div>

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="me-3">
                  <div>
                    <label style={{ color: "#000" }}>Search</label>
                    <input
                      type="text"
                      className="form-control form-control-sm me-2"
                      placeholder="Search by Name, Email, Phone, Loan No..."
                      style={{
                        backgroundColor: "#b4b4b447",
                        padding: "0.2rem 0.85rem",
                        marginTop: "5px",
                      }}
                      value={searchQuery}
                      onChange={handleSearchChange}
                    />
                  </div>
                </div>

                <div className="input-icon-end position-relative">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                    }}
                  >
                    <label style={{ color: "#000" }}>Date Range</label>
                    <PredefinedDateRanges state={state} setState={setState} />
                  </div>
                </div>
                <div style={{ margin: "0 1.5rem" }}>
                  <label style={{ color: "#000" }}>Total Disbursement Amount</label>
                  <div
                    style={{
                      background: "linear-gradient(135deg, #4CAF50, #2E7D32)",
                      color: "#fff",
                      borderRadius: "8px",
                      padding: "0.35rem 1rem",
                      marginTop: "5px",
                      fontWeight: 700,
                      fontSize: "14px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    ₹ {totalDisbursementAmount.toLocaleString("en-IN")}
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    margin: "20px 0px 0px 3rem",
                  }}
                >
                  <div className="dropdown me-3">
                    <Link
                      style={{
                        background: "#3ab54bbf",
                        color: "#fff",
                      }}
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      Export
                    </Link>

                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          <i className="ti ti-file-type-pdf me-1" />
                          Export as PDF
                        </Link>
                      </li>
                      <li>
                        <div
                          onClick={exportToExcel}
                          className="dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel{" "}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              {filteredEmployeeData && filteredEmployeeData.length > 0 && (
                <Table
                  dataSource={filteredEmployeeData}
                  columns={columns}
                  Selection={true}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="add_employee">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Add New Expenses</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="contact-grids-tab">
                <ul className="nav nav-underline" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="info-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#basic-info"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Basic Information
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="basic-info"
                  role="tabpanel"
                  aria-labelledby="info-tab"
                  tabIndex={0}
                >
                  <div className="modal-body pb-0 ">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Title <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="name"
                            value={name}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Amount
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="number"
                            name="rate"
                            value={rate}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Description
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="textarea"
                            name="address"
                            value={address}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-light border me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      data-bs-dismiss="modal"
                      className="btn btn-primary"
                    >
                      Submit{" "}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {successCreation && <EmpSuccess all_routes={all_routes} />}
    </>
  );
};

export default DisburseMent_Loan;
